export default __webpack_public_path__ + "static/media/KeneticHoldings-logo.0e3d359d.svg";